import React, { Component } from 'react';
import Input from './Input';
import Button from './Button';
import Icon from './Icon';

// Import the CSS
import '../../scss/components/_input-list.scss';

/**
 * Populates the specified array with empty strings
 * until the length of the array matches `min`.
 */
function populateMinValues(values, min) {
	for (let i = values.length; i < min; i++) {
		values.push('');
	}
}

export default class InputList extends Component {
	constructor(props) {
		super(props);

		const values = this.props.values;

		// Make sure we have a minimum number of values
		populateMinValues(values, this.props.min);

		this.state = {
			values,
		};

		this.handleClickAddInput.bind(this);
	}

	componentWillReceiveProps(props) {
		// Make sure we have a minimum number of values
		populateMinValues(props.values, this.props.min);

		this.setState({ values: props.values });
	}

	handleClickAddInput() {
		const values = this.state.values.slice();

		// Add a new empty value to the end of the list
		values.push('');

		// Execute the `onChange()` method with the new set of values
		this.props.onChange(values);
	}

	handleClickRemoveInput(e, index) {
		e.preventDefault();

		const values = [];

		for (let i = 0; i < this.state.values.length; i++) {
			if (i !== index) {
				values.push(this.state.values[i]);
			}
		}

		// Execute the `onChange()` method with the new set of values
		this.props.onChange(values);
	}

	handleChangeInput(index, value) {
		const values = this.state.values.slice();

		// Set the value
		values[index] = value;

		// Execute the `onChange()` method with the new set of values
		this.props.onChange(values);
	}

	render() {
		return (
			<div className="input-list">
				{this.state.values.map((value, index) => {
					const name = `${this.props.name}[${index}]`;

					const isInputValid =
						this.props.validateFunction && value !== ''
							? this.props.validateFunction(value)
							: true;

					return (
						<div key={`input-${index}`}>
							<div className="input-list-row">
								<Input
									name={name}
									value={value}
									onChange={e => this.handleChangeInput(index, e.target.value)}
									{...this.props.inputProps}
								/>

								<If
									condition={
										!this.props.min || this.state.values.length > this.props.min
									}>
									<a
										href="#"
										onClick={e => this.handleClickRemoveInput(e, index)}>
										<Icon type="trash" />
									</a>
								</If>
							</div>
							{!isInputValid && (
								<div className="input-error-text">{this.props.errorText}</div>
							)}
						</div>
					);
				})}

				<If condition={!this.props.max || this.state.values.length < this.props.max}>
					<Button
						style="blue-border"
						size="small"
						onClick={() => this.handleClickAddInput()}>
						<Icon type="plus" /> Add More
					</Button>
				</If>
			</div>
		);
	}
}

InputList.propTypes = {
	name: React.PropTypes.string.isRequired,
	values: React.PropTypes.array,
	min: React.PropTypes.number,
	max: React.PropTypes.number,
	onChange: React.PropTypes.func.isRequired,
	inputProps: React.PropTypes.object,
	validateFunction: React.PropTypes.func,
	errorText: React.PropTypes.string,
};

InputList.defaultProps = {
	values: [],
	min: 0,
	max: null,
	inputProps: {},
};



// WEBPACK FOOTER //
// ./src/assets/js/components/InputList.js